const PIXEL_ID = '9m2hhhS3HNBMnVPjjP1okQ';
type Oaiq = ((...args: unknown[]) => void) & { q: unknown[][] };
let loaded = false;

export const openAIPixelLoaded = () => loaded;

/** Load only in the public landing document; navigation must unload the SDK. */
export function loadOpenAIPixel() {
  if (loaded || window.location.pathname !== '/') return;
  const target = window as Window & { oaiq?: Oaiq };
  if (target.oaiq) return;
  const oaiq: Oaiq = Object.assign((...args: unknown[]) => { oaiq.q.push(args); }, { q: [] as unknown[][] });
  target.oaiq = oaiq;
  oaiq('init', { pixelId: PIXEL_ID, debug: true });
  oaiq('measure', 'page_viewed', { type: 'contents' });
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
  script.referrerPolicy = 'no-referrer';
  loaded = true;
  document.head.appendChild(script);
}
